import Collection from './Collection'

class PagedCollection extends Collection {
    constructor(createItemCb = undefined, params = {}) {
        super(createItemCb, params)
        this._currentPage = params.page || 1
        this._itemsPerPage = params.itemsPerPage || params.limit || 20
        this._lastPage = 0
        this._total = 0
        this._params = Object.assign(params, {
            page: this._currentPage,
            items_per_page: this._itemsPerPage,
            limit: this._itemsPerPage,
        })
    }

    async fetch(params = {}, dontReset = false, extraOptions, loader = true) {
        const res = await super.fetch(params, dontReset, extraOptions, loader)
        // The client resolves a network error with undefined: keep the paging state of the
        // last good response, otherwise itemsPerPage turns undefined and the list's page
        // markers become "NaN" (sent as page=NaN, tasks#134).
        if (!res) return res
        this._currentPage = res?.current_page
        this._lastPage = res?.last_page
        this._itemsPerPage = res?.items_per_page || res?.limit
        this._total = res?.total || res?.data?.length
        return res
    }

    next() {
        if (this.hasMore && !this.loading) {
            this._currentPage++
            this.fetch({ page: this._currentPage }, true)
        }
    }

    get page() {
        return this._currentPage
    }

    get itemsPerPage() {
        return this._itemsPerPage
    }

    get hasMore() {
        return this._currentPage < this._lastPage
    }

    get total() {
        return this._total || 0
    }

    reset() {
        super.reset()
        this._total = 0
    }
}

export default PagedCollection
